import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import esES from 'antd/locale/es_ES';
import LoginPage from './pages/LoginPage';
import MainLayout from './components/MainLayout';

import Dashboard from './pages/Dashboard';
import GobernantaPage from './pages/GobernantaPage';

import Agencias from './pages/Agencias';
import Particulares from './pages/Particulares';
import HabitacionesVenta from './pages/HabitacionesVenta.js';
import Habitaciones from './pages/Habitaciones.js';
import Tarifas from './pages/Tarifas.js';
import LineasContrato from './pages/LineasContrato';

import TiposIVA from './pages/TiposIVA.js';
import Secciones from './pages/Secciones.js';
import Cargos from './pages/Cargos.js';
import FormasPago from './pages/FormasPago.js'
import TiposRegimen from './pages/TiposRegimen.js'
import Cancelaciones from './pages/Cancelaciones.js';
import Idiomas from './pages/Idiomas.js';
import TiposComunicacion from './pages/TiposComunicacion.js'
import EstadosReserva from './pages/ReservasEstados.js'
import Series from './pages/Series.js'
import TiposFacturacion from './pages/TiposFacturacion.js'
// import Reservas from './pages/Reservas.js'
import Reservas from './pages/Reservas.js'
import Paises from './pages/Paises.js'
import Provincias from './pages/Provincias.js'
import CheckinCheckout from './pages/CheckinCheckout.js'
import Comedor from './pages/Comedor.js';
import PlaningHabitacionesVenta from './pages/PlaningHabitacionesEspeciales.js';

import ProtectedRoute from './components/ProtectedRoute';
import Ocupacion from './pages/Ocupacion.js';

import PrevisionEntradasSalidas from './pages/PrevisionEntradasSalidas.js'
import ServicioCocina from './pages/ServicioCocina.js'

import EditarReserva from './components/EditarReserva.js'
import Facturas from './pages/Facturas.js';

import ControlSynergy from './pages/Synergy.js'
import ImportarReservas from './pages/ImportarReservas.js'
import XMLConfiguracion from './pages/XMLConfiguracion.js'
import PlaningHabitaciones from './pages/PlaningHabitaciones.js';
import PlaningHabitaciones2 from './pages/PlaningHabitaciones2.js';

import ListadoGobernanta from './pages/ListadoGobernanta.js'
import LocalizarHuesped from './pages/LocalizarHuesped.js';
import HabitacionesLibres from './pages/HabitacionesLibres.js';
import PanelListados from './pages/PanelListados.js';
import Incidencias from './pages/Incidencias.js';
import TextosLegales from './pages/TextosLegales.js';
import Usuarios from './pages/Usuarios.js';
import Roles from './pages/Roles.js';

function App() {
  return (
    <ConfigProvider locale={esES}>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
          </Route>
          
          <Route path="/gobernanta" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<GobernantaPage />} />
          </Route>
          <Route path="/agencias" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<Agencias />} />
          </Route>          
          <Route path="/particulares" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<Particulares />} />
          </Route>                    
          <Route path="/habitacionesventa" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<HabitacionesVenta />} />
          </Route>                              
          <Route path="/habitaciones" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<Habitaciones />} />
          </Route>                              
          <Route path="/tarifas" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<Tarifas />} />
          </Route>                                        
          <Route path="/lineas-contrato/:codigoContrato" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<LineasContrato />} />
          </Route>                                                  
          <Route path="/tiposiva" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<TiposIVA />} />
          </Route>                                                            
          <Route path="/secciones" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<Secciones />} />
          </Route>                                                                      
          <Route path="/cargos" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<Cargos />} />
          </Route>                                                                                
          <Route path="/formaspago" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<FormasPago />} />
          </Route>     
          <Route path="/tiposregimen" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<TiposRegimen />} />
          </Route>               
          <Route path="/cancelaciones" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<Cancelaciones />} />
          </Route>  
          <Route path="/idiomas" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<Idiomas />} />
          </Route>            
          <Route path="/tiposcomunicacion" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<TiposComunicacion />} />
          </Route>                   
          <Route path="/reservasestados" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<EstadosReserva />} />
          </Route>                       
          <Route path="/tiposfacturacion" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<TiposFacturacion />} />
          </Route>                             
          <Route path="/series" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<Series />} />
          </Route>                                 
          <Route path="/reservas" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<Reservas />} />
          </Route>                

          <Route path="/reservas/nueva" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<EditarReserva  />} />
          </Route>                          
          <Route path="/reservas/:id" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<EditarReserva  />} />
          </Route>                                                                                    

          {/* <Route path="/reservas/:id" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<Reservas />} />
          </Route>                          
          <Route path="/reservas/:id/editar" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<Reservas />} />
          </Route>                                                                           */}

          <Route path="/paises" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<Paises />} />
          </Route>                                                
          <Route path="/provincias" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<Provincias />} />
          </Route>                                                          

          <Route path="/checkin-checkout" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<CheckinCheckout />} />
          </Route>                                                          
          <Route path="/comedor" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<Comedor />} />
          </Route>                        
          <Route path="/planinghabitacionesventa" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<PlaningHabitacionesVenta />} />
          </Route>                     
          <Route path="/ocupacion" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<Ocupacion />} />
          </Route>                           
          <Route path="/previsionentradassalidas" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<PrevisionEntradasSalidas />} />
          </Route>                
          <Route path="/serviciococina" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<ServicioCocina />} />
          </Route>                
          <Route path="/facturas" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<Facturas />} />
          </Route>               
          <Route path="/controlsynergy" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<ControlSynergy />} />
          </Route>               
          <Route path="/importarreservas" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<ImportarReservas />} />
          </Route>               
          <Route path="/xmlconfiguracion" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<XMLConfiguracion />} />
          </Route>               
          <Route path="/planinghabitaciones" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<PlaningHabitaciones />} />
          </Route>               
          <Route path="/listadogobernanta" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<ListadoGobernanta />} />
          </Route>               
          <Route path="/localizarhuesped" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<LocalizarHuesped />} />
          </Route>               

          <Route path="/habitacioneslibres" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<HabitacionesLibres />} />
          </Route>                         
          <Route path="/panellistados" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<PanelListados />} />
          </Route>                                   
          <Route path="/incidencias" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<Incidencias />} />
          </Route>                                             

          <Route path="/textos" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<TextosLegales />} />
          </Route>                                                       
          <Route path="/usuarios" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<Usuarios />} />
          </Route>                                                       
          <Route path="/roles" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route index element={<Roles />} />
          </Route>                                                                 


          <Route path="*" element={<Navigate to="/" replace />} />    

        </Routes>
      </Router>
    </ConfigProvider>
  );
}

export default App;
